import React, { useEffect, useMemo, useState } from "react";
import MdaeDateBox from "../../common_components/common_widgets/date-box";
import { callOperation, actions } from "async-ops";
import MdaeSelectBox from "../../common_components/common_widgets/select-box";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import MdaeButton from "../../common_components/common_widgets/button";
import {
  defaultBulkEditUserTaskData,
  formatUserTaskObjectToSave,
  SET_USER_TASK_BULK_EDIT_DATA,
  SET_BULK_EDIT_USER_TASK_POPUP_MODE,
  SET_USER_TASK_SELECTED_ROWS_DATA,
  TOGGLE_BULK_EDIT_USER_TASK_POPUP,
  SET_POPUP_OPENED_FROM_COMPLETED_BY_BULK_EDIT,
  SET_ASSIGNED_USER_TYPE,
  SET_SELECT_GROUP_DATAGRID_INSTANCE,
  SET_CURRENT_SELECTED_GROUP_ROW_DATA,
  formatTaskListForBulkUpdate,
} from "./reducers/user-task-list-reducer";
import { useSelector, useDispatch } from "react-redux";
import { cloneDeep, cloneDeepWith, isEqual } from "lodash";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_NOTIFY_POPUP,
} from "../../common_components/mdae-common-reducer";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../../common_components/common_widgets/toast/notify";
import { BULK_UPDATE_USER_TASK } from "./services/bulk-update-user-tasks";
import { Validator } from "devextreme-react";
import { CustomRule } from "devextreme-react/data-grid";
import { BULK_EDIT_USER_TASK_POPUP_MODE } from "./component";
import NotifyPopup, {
  NOTIFY_POPUP_TYPES,
} from "../common_widgets/notify-popup";
import { GET_ACTIVE_USERS_LIST } from "./services/get-active-users-list";
import $ from "jquery";
import { showNewTasksCreatedPopup, toggleSelectExternalUserPopup } from "./add-user-task";
import SelectExternalUser from "../select-external-user";
import { USER_TYPE } from "./constant";
import { GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION } from "./services/get-external-user-group-list-with-association";
import SelectAssignedGroupUser, {
  toggleSelectAssignedGroupUserPopup,
} from "../select-assigned-user/component";
import { GET_TASK_GROUP_LIST_WITH_ASSOCIATION } from "./services/get-task-group-list-with-association";
import { TASK_GROUPS, getUserPermissionObject, hasAnyFeatureGroupAccess } from "../user-permissions-helper";
export const openBulkEditUserTasksPopup = (
  currentSelectedRowsData,
  toggleBulkEditUserTaskPopup,
  dispatch
) => {
  toggleBulkEditUserTaskPopup(true, "Edit Tasks");
  dispatch({
    type: SET_USER_TASK_SELECTED_ROWS_DATA,
    data: { currentSelectedRowsData: currentSelectedRowsData },
  });
  dispatch({
    type: SET_USER_TASK_BULK_EDIT_DATA,
    data: { userTaskBulkEditData: defaultBulkEditUserTaskData },
  });
  dispatch({
    type: SET_BULK_EDIT_USER_TASK_POPUP_MODE,
    data: {
      bulkEditUserTaskPopupMode: BULK_EDIT_USER_TASK_POPUP_MODE.BULK_EDIT,
    },
  });
};
export const openReassignUserTasksPopup = (
  currentSelectedRowsData,
  toggleBulkEditUserTaskPopup,
  dispatch
) => {
  toggleBulkEditUserTaskPopup(true, "Reassign Tasks");
  dispatch({
    type: SET_USER_TASK_SELECTED_ROWS_DATA,
    data: { currentSelectedRowsData: currentSelectedRowsData },
  });
  dispatch({
    type: SET_USER_TASK_BULK_EDIT_DATA,
    data: { userTaskBulkEditData: defaultBulkEditUserTaskData },
  });
  dispatch({
    type: SET_BULK_EDIT_USER_TASK_POPUP_MODE,
    data: {
      bulkEditUserTaskPopupMode: BULK_EDIT_USER_TASK_POPUP_MODE.REASSIGN,
    },
  });
};
interface IBulkEditUserTaskPopup {
  refreshUserTaskListFunction?: () => void;
  toggleBulkEditUserTaskPopup: (isVisible: boolean, title?: string) => void;
  userTaskBulkEditPopupTitle?: string;
  toggleUserTaskGridCheckboxesForMyTask: () => void;
  isManagerView?:boolean
}
const BulkEditUserTaskPopup: React.FC<IBulkEditUserTaskPopup> = (props) => {
  const dispatch = useDispatch();
  const BulkEditUserTaskValidationGroup = "BulkEditUserTaskValidationGroup";
  const bulkEditUserTaskPopupMode = useSelector(
    (state: any) => state["userTaskListReducer"].bulkEditUserTaskPopupMode,
    isEqual
  );
  const currentSelectedRowsData = useSelector(
    (state: any) => state["userTaskListReducer"].currentSelectedRowsData,
    isEqual
  );
  const currentUserId: any = useSelector(
    (state) => state["userTaskListReducer"].currentUserId,
    isEqual
  );
  const userTaskStatusList = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskStatusList,
    isEqual
  );
  const userTaskBulkEditData = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskBulkEditData
  );
  const auditorList = useSelector(
    (state: any) => state["userTaskListReducer"].auditorList,
    isEqual
  );
  const completedStatusValue = useSelector(
    (state: any) => state["userTaskListReducer"].completedStatusValue,
    isEqual
  );
  const allActiveUserList = useSelector(
    (state: any) => state["userTaskListReducer"].assignedToUserList,
    isEqual
  );
  const externalUserList = useSelector(
    (state: any) =>
      state.externalUsersReducer.externalUserListForExternalUserGroup,
    isEqual
  );
  const taskGroupList = useSelector(
    (state: any) => state.taskGroupReducer.taskGroupList
  );
  const externalUserGroupList = useSelector(
    (state: any) => state.externalUsersReducer.externalUserGroupList
  );
  const isSelectAssignedGroupUserPopupVisible = useSelector(
    (state: any) =>
      state.userTaskListReducer.isSelectAssignedGroupUserPopupVisible
  );
  const isSelectExternalUserPopupVisible = useSelector(
    (state: any) => state.userTaskListReducer.isSelectExternalUserPopupVisible,
    isEqual
  );
  const isBulkEditUserTaskPopupVisible = useSelector(
    (state: any) => state.userTaskListReducer.isBulkEditUserTaskPopupVisible,
    isEqual
  );
  const isBulkTaskAssignedToGroup = useSelector(
    (state: any) => state.userTaskListReducer.isBulkTaskAssignedToGroup
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser
  );
  const taskGroupPermission = getUserPermissionObject(
    "TASK_GROUPS",
    currentUser
  );
  const qaReviewPermission = getUserPermissionObject(
    "ALL_AUDITS_FOR_QA_REVIEW||MY_AUDITS_FOR_QA_REVIEW",
    currentUser
  );
  const hasTaskGroupAccess = useMemo(
    () => hasAnyFeatureGroupAccess([TASK_GROUPS], currentUser),
    [currentUser]
  );
  const hasTaskGroupAccessOnly =
    taskGroupPermission.hasUpdateAccess &&
    !(
      qaReviewPermission.hasAllAuditsForQaReviewUpdateAccess &&
      qaReviewPermission.hasMyAuditsForQaReviewUpdateAccess
    );
  useEffect(() => {
    if (!allActiveUserList || allActiveUserList?.length === 0)
      dispatch(actions.asyncOperationStart(GET_ACTIVE_USERS_LIST, {}));
  }, []);
  const [
    userTaskBulkEditGridInstance,
    setUserTaskBulkEditGridInstance,
  ] = useState(null);
  const onUserTaskBulkEditGridInstance = (e) => {
    setUserTaskBulkEditGridInstance(e.component);
  };
  const getUserTaskSelectedIds = (selectedRowsData) => {
    var listItemId = selectedRowsData.map((item) => item.userTaskId);
    return listItemId;
  };
  const updateUserTaskData = (params, isClosePopup) => {
    let result = null;
    if (
      !userTaskBulkEditData.scheduledDate &&
      userTaskBulkEditData.scheduleTime
    ) {
      dispatch({
        type: TOGGLE_NOTIFY_POPUP,
        data: {
          visible: true,
          contentHtml: () => {
            return (
              <div>
                A rescheduled date is required when a scheduled time is added.
              </div>
            );
          },
          notifyPopupType: NOTIFY_POPUP_TYPES.ERROR,
          closeButtonText: "OK",
          width: 470,
          height: 220,
        },
      });
      return;
    }
    if (params.validationGroup) result = params.validationGroup.validate();
    if (
      (result && result.isValid) ||
      bulkEditUserTaskPopupMode == BULK_EDIT_USER_TASK_POPUP_MODE.REASSIGN
    ) {
      dispatch({ type: SHOW_LOADER });
      const dataToSave = formatUserTaskObjectToSave(userTaskBulkEditData);
      dataToSave.taskToUpdate = formatTaskListForBulkUpdate(userTaskBulkEditData, currentSelectedRowsData);
      callOperation(BULK_UPDATE_USER_TASK, dataToSave).then(function(response) {
        dispatch({ type: HIDE_LOADER });
        props.toggleUserTaskGridCheckboxesForMyTask();
        if (response?.isUpdated) {
          if (typeof props.refreshUserTaskListFunction === "function")
            props.refreshUserTaskListFunction();
          mdaeNotify({
            message: "Tasks Updated successfully.",
            messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
          });

          showNewTasksCreatedPopup(dispatch, false, response, -1)
        }
        props.toggleBulkEditUserTaskPopup(false);
      });
    }
  };
  const getUserTaskPopupTitle = () => {
    return (
      <MdaePopupTitle
        isSmallPopup={
          bulkEditUserTaskPopupMode == BULK_EDIT_USER_TASK_POPUP_MODE.REASSIGN
            ? true
            : false
        }
        closePopupHandler={() => {
          props.toggleBulkEditUserTaskPopup(false);
          props.toggleUserTaskGridCheckboxesForMyTask();
        }}
      >
        {props.userTaskBulkEditPopupTitle}
      </MdaePopupTitle>
    );
  };
  const taskStatusValueChanged = (e) => {
    const tmpUserTaskBulkEditData: any = {};
    if (userTaskBulkEditData.statusId == completedStatusValue && e.value) {
      if (!userTaskBulkEditData.completedByUsedId) {
        tmpUserTaskBulkEditData.completedByUsedId = currentUserId;
      }
      if (!userTaskBulkEditData.completionDate) {
        tmpUserTaskBulkEditData.completionDate = new Date();
      }
    } else {
      tmpUserTaskBulkEditData.completeInd = false;
      tmpUserTaskBulkEditData.completedByUsedId = null;
      tmpUserTaskBulkEditData.completionDate = null;
    }
    if (!e.value) {
      tmpUserTaskBulkEditData.statusId = 0;
    } else if (e.event) tmpUserTaskBulkEditData.statusId = e.value;
    dispatch({
      type: SET_USER_TASK_BULK_EDIT_DATA,
      data: { userTaskBulkEditData: tmpUserTaskBulkEditData },
    });
  };
  const onCompletedByValueChange = (e) => {
    const tmpUserTaskBulkEditData: any = {};
    if (e.value) {
      if (userTaskBulkEditData.statusId != completedStatusValue) {
        tmpUserTaskBulkEditData.statusId = completedStatusValue;
      }
      if (!userTaskBulkEditData.completionDate) {
        tmpUserTaskBulkEditData.completionDate = new Date();
      }
      tmpUserTaskBulkEditData.completedByUsedId = e.value;
    }
    if (e.value !== -1 && e.event) {
      tmpUserTaskBulkEditData.isCompletedByExternalUser = false;
      tmpUserTaskBulkEditData.completedByUsedId = e.value;
    } else if (e.value === -1 && e.event) {
      dispatch({
        type: SET_POPUP_OPENED_FROM_COMPLETED_BY_BULK_EDIT,
        data: {
          isSelectUserPopupOpenedFromCompletedByBulkEdit: true,
        },
      });
      toggleSelectExternalUserPopup(dispatch, true);
      tmpUserTaskBulkEditData.completedByUsedId =
        e.previousValue === null ? 0 : e.previousValue;
    }
    dispatch({
      type: SET_USER_TASK_BULK_EDIT_DATA,
      data: { userTaskBulkEditData: tmpUserTaskBulkEditData },
    });
  };
  const onCompletedOnValueChange = (e) => {
    const tmpUserTaskBulkEditData: any = {};
    if (e.value) {
      if (userTaskBulkEditData.statusId != completedStatusValue) {
        tmpUserTaskBulkEditData.statusId = completedStatusValue;
      }
      if (!userTaskBulkEditData.completedByUsedId) {
        tmpUserTaskBulkEditData.completedByUsedId = currentUserId;
      }
    }
    tmpUserTaskBulkEditData.completionDate = e.value;
    dispatch({
      type: SET_USER_TASK_BULK_EDIT_DATA,
      data: { userTaskBulkEditData: tmpUserTaskBulkEditData },
    });
  };

  const getUserTaskSelectedAuditGroupIds = (selectedRowsData) => {
    const auditGroupIds = [];
    selectedRowsData.forEach((item) => {
      if (item?.auditGroupId > 0) auditGroupIds.push(item.auditGroupId);
    });
    return auditGroupIds;
  };
  const checkIfAssignedToExternalUser = (assignedToUserList) => {
    if (userTaskBulkEditData.isAssignedToExternalUser) {
      let selectedExternalUser = externalUserList?.find(
        (x) => x.externalUserId === userTaskBulkEditData.assignedToUserId
      );
      if (selectedExternalUser?.externalUserId > 0) {
        selectedExternalUser.fullName =
          selectedExternalUser.externalUserName + ` (External User)`;
        selectedExternalUser.auditUserId = selectedExternalUser.externalUserId;
      }
      if (selectedExternalUser) assignedToUserList.push(selectedExternalUser);
    }
    if (userTaskBulkEditData.isCompletedByExternalUser) {
      let selectedExternalUser = externalUserList?.find(
        (x) => x.externalUserId === userTaskBulkEditData.completedByUsedId
      );
      if (selectedExternalUser?.externalUserId > 0) {
        selectedExternalUser.fullName =
          selectedExternalUser.externalUserName + ` (External User)`;
        selectedExternalUser.auditUserId = selectedExternalUser.externalUserId;
      }
      if (
        selectedExternalUser &&
        !assignedToUserList.find(
          (x) => x.auditUserId === selectedExternalUser?.auditUserId
        )
      )
        assignedToUserList.push(selectedExternalUser);
    }
    return assignedToUserList;
  };

  const checkIfAssignedToExternalUserGroup = (assignedToUserList) => {
    let selectedExternalUserGroup = externalUserGroupList?.find(
      (x) => x.externalUserGroupId === userTaskBulkEditData.assignedToUserId
    );
    if (selectedExternalUserGroup?.externalUserGroupId > 0) {
      selectedExternalUserGroup.fullName =
        selectedExternalUserGroup.externalUserGroupName +
        ` (External User Group)`;
      selectedExternalUserGroup.auditUserId =
        selectedExternalUserGroup.externalUserGroupId;
    }
    if (selectedExternalUserGroup)
      assignedToUserList.push(selectedExternalUserGroup);
    return assignedToUserList;
  };

  const checkIfAssignedToTaskGroup = (assignedToUserList) => {
    let selectedTaskGroup = taskGroupList?.find(
      (x) => x.taskGroupId === userTaskBulkEditData.assignedToUserId
    );
    if (selectedTaskGroup?.taskGroupId > 0) {
      selectedTaskGroup.fullName =
        selectedTaskGroup.taskGroupName + ` (Task Group)`;
      selectedTaskGroup.auditUserId = selectedTaskGroup.taskGroupId;
    }
    if (selectedTaskGroup) assignedToUserList.push(selectedTaskGroup);
    return assignedToUserList;
  };

  const getAssignToList = (data, isFromAssignedToField = false) => {
    if (currentUser?.isTaskHQAccessEnabled || hasTaskGroupAccessOnly) {
      return allActiveUserList || [];
    } else if (data != "" || data.length > 0) {
      var auditgroupIds = getUserTaskSelectedAuditGroupIds(data);
      if (auditgroupIds.length > 0) {
        let uniqueAuditgroupIds = auditgroupIds.filter(function(
          item,
          pos,
          self
        ) {
          return self.indexOf(item) == pos;
        });
        var assignedToList = [];
        var len = auditorList.length;
        for (var i = 0, len = len; i < len; i++) {
          if (uniqueAuditgroupIds.includes(auditorList[i].auditGroupId)) {
            assignedToList.push(auditorList[i]);
          }
        }
        var flags = {};
        var uniqueAuditorList = [];
        uniqueAuditorList = auditorList.filter(function(entry) {
          if (flags[entry.auditUserId]) {
            return false;
          }
          flags[entry.auditUserId] = true;
          return true;
        });
        var length = uniqueAuditorList.length;
        for (var j = 0; j < length; j++) {
          uniqueAuditorList[j]["totalGroupIds"] = [];
          for (var item of assignedToList) {
            if (uniqueAuditorList[j].auditUserId == item.auditUserId) {
              uniqueAuditorList[j].totalGroupIds.push(item.auditGroupId);
            }
          }
        }
        assignedToList = [];
        for (var items of uniqueAuditorList) {
          if (
            JSON.stringify(items.totalGroupIds.sort()) ===
            JSON.stringify(uniqueAuditgroupIds.sort())
          ) {
            assignedToList.push(items);
          }
        }
        if (isFromAssignedToField == true){
          if (taskGroupList?.length > 0 && hasTaskGroupAccess) {
            let taskGroup = { auditUserId: -3, fullName: "Task Group" };
            assignedToList.unshift(taskGroup);
          }
          if (externalUserGroupList?.length > 0 ) {
            let externalUserGroup = {
              auditUserId: -2,
              fullName: "External User Group",
            };
            assignedToList.unshift(externalUserGroup);
          }
        }
        if (externalUserList?.length > 0) {
          let externalUser = { auditUserId: -1, fullName: "External User" };
          assignedToList.unshift(externalUser);
        }
        if (userTaskBulkEditData?.assignedUserType == USER_TYPE.NORMAL) {
          assignedToList = checkIfAssignedToExternalUser(assignedToList);
        } else if (userTaskBulkEditData?.assignedUserType == USER_TYPE.EG) {
          assignedToList = checkIfAssignedToExternalUserGroup(assignedToList);
        } else if (userTaskBulkEditData?.assignedUserType == USER_TYPE.TG) {
          assignedToList = checkIfAssignedToTaskGroup(assignedToList);
        }
        return assignedToList;
      } else {
        let assignedToUserList = cloneDeep(allActiveUserList);
        if (isFromAssignedToField == true){
          if (taskGroupList?.length > 0 && hasTaskGroupAccess) {
            let taskGroup = { auditUserId: -3, fullName: "Task Group" };
            assignedToList.unshift(taskGroup);
          }
          if (externalUserGroupList?.length > 0) {
            let externalUserGroup = {
              auditUserId: -2,
              fullName: "External User Group",
            };
            assignedToList.unshift(externalUserGroup);
          }
        }

        if (externalUserList?.length > 0) {
          let externalUser = { auditUserId: -1, fullName: "External User" };
          assignedToUserList.unshift(externalUser);
        }
        if (userTaskBulkEditData?.assignedUserType == USER_TYPE.NORMAL) {
          assignedToList = checkIfAssignedToExternalUser(assignedToList);
        } else if (userTaskBulkEditData?.assignedUserType == USER_TYPE.EG) {
          assignedToList = checkIfAssignedToExternalUserGroup(assignedToList);
        } else if (userTaskBulkEditData?.assignedUserType == USER_TYPE.TG) {
          assignedToList = checkIfAssignedToTaskGroup(assignedToList);
        }
        return assignedToUserList || [];
      }
    } else {
      return {};
    }
  };
  const validateCompletedOn = (e) => {
    if (userTaskBulkEditData.statusId == completedStatusValue && !e.value) {
      return false;
    } else return true;
  };
  const validateCompletedBy = (e) => {
    if (userTaskBulkEditData.statusId == completedStatusValue && !e.value) {
      return false;
    } else return true;
  };

  return (
    <>
      {isSelectExternalUserPopupVisible && isBulkEditUserTaskPopupVisible && (
        <SelectExternalUser
          isPopupOpenedFromBulkEdit={true}
          getAssignToList={getAssignToList}
          selectedRowsDataForBulkEdit={currentSelectedRowsData}
        ></SelectExternalUser>
      )}
      {isSelectAssignedGroupUserPopupVisible &&
        isBulkEditUserTaskPopupVisible && (
          <SelectAssignedGroupUser
            isPopupOpenedFromBulkEdit={true}
            getAssignToList={getAssignToList}
            selectedRowsDataForBulkEdit={currentSelectedRowsData}
          ></SelectAssignedGroupUser>
        )}
      <MdaePopup
        deferRendering={false}
        height={
          bulkEditUserTaskPopupMode == BULK_EDIT_USER_TASK_POPUP_MODE.REASSIGN
            ? 220
            : 352
        }
        width={
          bulkEditUserTaskPopupMode == BULK_EDIT_USER_TASK_POPUP_MODE.REASSIGN
            ? 420
            : 600
        }
        id={"pnlBulkEditUserTaskPopup"}
        mdaeTitleRender={getUserTaskPopupTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_BULK_EDIT_USER_TASK_POPUP,
            reducerName: "userTaskListReducer",
            widgetOptionBindings: {
              visible: "isBulkEditUserTaskPopupVisible",
              mdaePopupTitle: "userTaskBulkEditPopupTitle",
            },
          },
        ]}
        mdaeContentRender={() => {
          if (
            bulkEditUserTaskPopupMode == BULK_EDIT_USER_TASK_POPUP_MODE.REASSIGN
          ) {
            return (
              <MdaePopupContent>
                <div className={"widget-separation-margin-top"}>
                  <MdaeSelectBox
                    id={"ddlAssignTo"}
                    mdaeDropDownBoxTitle={"Assigned To"}
                    displayExpr={"fullName"}
                    valueExpr={"auditUserId"}
                    dataSource={getAssignToList(currentSelectedRowsData,true)}
                    itemRender={(e) => {
                      if (e?.auditUserId < 0) {
                        return (
                          <div className="reassign-external-user-item">
                            <div>{e.fullName}</div>
                          </div>
                        );
                      } else return <div>{e?.fullName}</div>;
                    }}
                    onOpened={(e) => {
                      setTimeout(() => {
                        $(
                          ".dx-item.dx-list-item:has(.reassign-external-user-item)"
                        ).addClass("external-user-border");
                      }, 10);
                    }}
                    onValueChanged={(e) => {
                      if (e.value && e.event) {
                        if (e.value > 0) {
                          dispatch({
                            type: SET_USER_TASK_BULK_EDIT_DATA,
                            data: {
                              userTaskBulkEditData: {
                                assignedToUserId: e.value,
                                isAssignedToExternalUser: false,
                                assignedUserType: USER_TYPE.NORMAL,
                              },
                            },
                          });
                          dispatch({
                            type: SET_ASSIGNED_USER_TYPE,
                            data: {
                              assignedUserType: USER_TYPE.NORMAL,
                            },
                          });
                        } else if (e.value === -1) {
                          dispatch({
                            type: SET_POPUP_OPENED_FROM_COMPLETED_BY_BULK_EDIT,
                            data: {
                              isSelectUserPopupOpenedFromCompletedByBulkEdit: false,
                            },
                          });
                          dispatch({
                            type: SET_ASSIGNED_USER_TYPE,
                            data: {
                              assignedUserType: USER_TYPE.NORMAL,
                            },
                          });
                          toggleSelectExternalUserPopup(dispatch, true);
                          dispatch({
                            type: SET_USER_TASK_BULK_EDIT_DATA,
                            data: {
                              userTaskBulkEditData: {
                                assignedToUserId:
                                  e.previousValue === null
                                    ? 0
                                    : e.previousValue,
                                assignedUserType: USER_TYPE.NORMAL,
                              },
                            },
                          });
                        } else if (e.value === -2) {
                          dispatch(
                            actions.asyncOperationStart(
                              GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION,
                              {}
                            )
                          );
                          toggleSelectAssignedGroupUserPopup(dispatch, true);
                          dispatch({
                            type: SET_USER_TASK_BULK_EDIT_DATA,
                            data: {
                              userTaskBulkEditData: {
                                assignedToUserId:
                                  e.previousValue === null
                                    ? 0
                                    : e.previousValue,
                              },
                            },
                          });
                          dispatch({
                            type: SET_ASSIGNED_USER_TYPE,
                            data: {
                              assignedUserType: USER_TYPE.EG,
                            },
                          });
                          dispatch({
                            type: SET_SELECT_GROUP_DATAGRID_INSTANCE,
                            data: {
                              selectGroupDataGridInstance: undefined,
                            },
                          });
                          dispatch({
                            type: SET_CURRENT_SELECTED_GROUP_ROW_DATA,
                            data: {
                              setCurrentSelectedGroupRowData: undefined,
                            },
                          });
                        } else if (e.value === -3) {
                          dispatch(
                            actions.asyncOperationStart(
                              GET_TASK_GROUP_LIST_WITH_ASSOCIATION,
                              {}
                            )
                          );
                          toggleSelectAssignedGroupUserPopup(dispatch, true);
                          dispatch({
                            type: SET_USER_TASK_BULK_EDIT_DATA,
                            data: {
                              userTaskBulkEditData: {
                                assignedToUserId:
                                  e.previousValue === null
                                    ? 0
                                    : e.previousValue,
                              },
                            },
                          });
                          dispatch({
                            type: SET_ASSIGNED_USER_TYPE,
                            data: {
                              assignedUserType: USER_TYPE.TG,
                            },
                          });
                          dispatch({
                            type: SET_SELECT_GROUP_DATAGRID_INSTANCE,
                            data: {
                              selectGroupDataGridInstance: undefined,
                            },
                          });
                          dispatch({
                            type: SET_CURRENT_SELECTED_GROUP_ROW_DATA,
                            data: {
                              setCurrentSelectedGroupRowData: undefined,
                            },
                          });
                        }
                      }
                    }}
                    mdaeDataUpdaterConfig={[
                      {
                        actionType: SET_USER_TASK_BULK_EDIT_DATA,
                        reducerName: "userTaskListReducer",
                        widgetOptionBindings: {
                          value: "userTaskBulkEditData.assignedToUserId",
                        },
                      },
                    ]}
                  ></MdaeSelectBox>
                </div>
              </MdaePopupContent>
            );
          } else {
            return (
              <MdaePopupContent>
                <div
                  className={
                    "create-task-template-container widget-separation-margin-top"
                  }
                >
                  <div className={"left-container"}>
                    <div className={"widget-separation-margin-top"}>
                      <MdaeSelectBox
                        id={"ddlTaskStatus"}
                        mdaeDropDownBoxTitle={"Task Status"}
                        dataSource={userTaskStatusList}
                        displayExpr={"displayAlias"}
                        valueExpr={"statusId"}
                        disabled={isBulkTaskAssignedToGroup}
                        value={userTaskBulkEditData.statusId}
                        onValueChanged={taskStatusValueChanged}
                        name="statusId"
                      >
                        {" "}
                        <Validator
                          validationGroup={BulkEditUserTaskValidationGroup}
                        ></Validator>
                      </MdaeSelectBox>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <MdaeSelectBox
                        id={"ddlAssignTo"}
                        mdaeDropDownBoxTitle={"Assigned To"}
                        displayExpr={"fullName"}
                        valueExpr={"auditUserId"}
                        dataSource={getAssignToList(currentSelectedRowsData,true)}
                        itemRender={(e) => {
                          if (e?.auditUserId < 0) {
                            return (
                              <div className="bulk-external-user-item">
                                <div>{e.fullName}</div>
                              </div>
                            );
                          } else return <div>{e?.fullName}</div>;
                        }}
                        value={userTaskBulkEditData.assignedToUserId}
                        onOpened={(e) => {
                          setTimeout(() => {
                            $(
                              ".dx-item.dx-list-item:has(.bulk-external-user-item)"
                            ).addClass("external-user-border");
                          }, 10);
                        }}
                        onValueChanged={(e) => {
                          if (e.value && e.event) {
                            if (e.value > 0) {
                              dispatch({
                                type: SET_USER_TASK_BULK_EDIT_DATA,
                                data: {
                                  userTaskBulkEditData: {
                                    assignedToUserId: e.value,
                                    isAssignedToExternalUser: false,
                                    assignedUserType: USER_TYPE.NORMAL,
                                  },
                                },
                              });
                              dispatch({
                                type: SET_ASSIGNED_USER_TYPE,
                                data: {
                                  assignedUserType: USER_TYPE.NORMAL,
                                },
                              });
                            } else if (e.value === -1) {
                              dispatch({
                                type: SET_POPUP_OPENED_FROM_COMPLETED_BY_BULK_EDIT,
                                data: {
                                  isSelectUserPopupOpenedFromCompletedByBulkEdit: false,
                                },
                              });
                              dispatch({
                                type: SET_ASSIGNED_USER_TYPE,
                                data: {
                                  assignedUserType: USER_TYPE.NORMAL,
                                },
                              });
                              toggleSelectExternalUserPopup(dispatch, true);
                              dispatch({
                                type: SET_USER_TASK_BULK_EDIT_DATA,
                                data: {
                                  userTaskBulkEditData: {
                                    assignedToUserId:
                                      e.previousValue === null
                                        ? 0
                                        : e.previousValue,
                                    assignedUserType: USER_TYPE.NORMAL,
                                  },
                                },
                              });
                            } else if (e.value === -2) {
                              dispatch(
                                actions.asyncOperationStart(
                                  GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION,
                                  {}
                                )
                              );
                              toggleSelectAssignedGroupUserPopup(
                                dispatch,
                                true
                              );
                              dispatch({
                                type: SET_USER_TASK_BULK_EDIT_DATA,
                                data: {
                                  userTaskBulkEditData: {
                                    assignedToUserId:
                                      e.previousValue === null
                                        ? 0
                                        : e.previousValue,
                                  },
                                },
                              });
                              dispatch({
                                type: SET_ASSIGNED_USER_TYPE,
                                data: {
                                  assignedUserType: USER_TYPE.EG,
                                },
                              });
                              dispatch({
                                type: SET_SELECT_GROUP_DATAGRID_INSTANCE,
                                data: {
                                  selectGroupDataGridInstance: undefined,
                                },
                              });
                              dispatch({
                                type: SET_CURRENT_SELECTED_GROUP_ROW_DATA,
                                data: {
                                  setCurrentSelectedGroupRowData: undefined,
                                },
                              });
                            } else if (e.value === -3) {
                              dispatch(
                                actions.asyncOperationStart(
                                  GET_TASK_GROUP_LIST_WITH_ASSOCIATION,
                                  {}
                                )
                              );
                              toggleSelectAssignedGroupUserPopup(
                                dispatch,
                                true
                              );
                              dispatch({
                                type: SET_USER_TASK_BULK_EDIT_DATA,
                                data: {
                                  userTaskBulkEditData: {
                                    assignedToUserId:
                                      e.previousValue === null
                                        ? 0
                                        : e.previousValue,
                                  },
                                },
                              });
                              dispatch({
                                type: SET_ASSIGNED_USER_TYPE,
                                data: {
                                  assignedUserType: USER_TYPE.TG,
                                },
                              });
                              dispatch({
                                type: SET_SELECT_GROUP_DATAGRID_INSTANCE,
                                data: {
                                  selectGroupDataGridInstance: undefined,
                                },
                              });
                              dispatch({
                                type: SET_CURRENT_SELECTED_GROUP_ROW_DATA,
                                data: {
                                  setCurrentSelectedGroupRowData: undefined,
                                },
                              });
                            }
                          }
                        }}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: SET_USER_TASK_BULK_EDIT_DATA,
                            reducerName: "userTaskListReducer",
                            widgetOptionBindings: {
                              value: "userTaskBulkEditData.assignedToUserId",
                            },
                          },
                        ]}
                      >
                        {" "}
                        <Validator
                          validationGroup={BulkEditUserTaskValidationGroup}
                        ></Validator>
                      </MdaeSelectBox>
                    </div>
                    {!currentUser?.isTaskHQAccessEnabled && (
                      <div className={"widget-separation-margin-top"}>
                        <MdaeDateBox
                          id="dtpCompletedOn"
                          mdaeDateBoxTitle="Completed On"
                          required={
                            userTaskBulkEditData.statusId ==
                            completedStatusValue
                          }
                          visible={
                            userTaskBulkEditData.statusId ==
                            completedStatusValue
                          }
                          name="completionDate"
                          disabled={isBulkTaskAssignedToGroup}
                          onValueChanged={onCompletedOnValueChange}
                          mdaeDataUpdaterConfig={[
                            {
                              actionType: SET_USER_TASK_BULK_EDIT_DATA,
                              reducerName: "userTaskListReducer",
                              widgetOptionBindings: {
                                value: "userTaskBulkEditData.completionDate",
                              },
                            },
                          ]}
                        >
                          <Validator
                            validationGroup={BulkEditUserTaskValidationGroup}
                          >
                            <CustomRule
                              validationCallback={validateCompletedOn}
                              message="Completion Date is required"
                            />
                          </Validator>
                        </MdaeDateBox>
                      </div>
                    )}
                  </div>
                  {!currentUser?.isTaskHQAccessEnabled && (
                    <div className={"right-container"}>
                      <div className={"widget-separation-margin-top"}>
                        <MdaeSelectBox
                          id={"ddlCompletedBy"}
                          mdaeDropDownBoxTitle={"Completed By"}
                          onValueChanged={onCompletedByValueChange}
                          displayExpr={"fullName"}
                          valueExpr={"auditUserId"}
                          disabled={isBulkTaskAssignedToGroup}
                          dataSource={getAssignToList(currentSelectedRowsData)}
                          required={
                            userTaskBulkEditData.statusId ==
                            completedStatusValue
                          }
                          visible={
                            userTaskBulkEditData.statusId ==
                            completedStatusValue
                          }
                          name="completedByUsedId"
                          itemRender={(e) => {
                            if (e?.auditUserId === -1) {
                              return (
                                <div className="bulk-completed-by-external-user-item">
                                  <div>{e.fullName}</div>
                                </div>
                              );
                            } else return <div>{e?.fullName}</div>;
                          }}
                          onOpened={(e) => {
                            setTimeout(() => {
                              $(
                                ".dx-item.dx-list-item:has(.bulk-completed-by-external-user-item)"
                              ).addClass("external-user-border");
                            }, 10);
                          }}
                          mdaeDataUpdaterConfig={[
                            {
                              actionType: SET_USER_TASK_BULK_EDIT_DATA,
                              reducerName: "userTaskListReducer",
                              widgetOptionBindings: {
                                value: "userTaskBulkEditData.completedByUsedId",
                              },
                            },
                          ]}
                        >
                          <Validator
                            validationGroup={BulkEditUserTaskValidationGroup}
                          >
                            <CustomRule
                              validationCallback={validateCompletedBy}
                              message="Completed by is required"
                            />
                          </Validator>
                        </MdaeSelectBox>
                      </div>
                      <div className={"widget-separation-margin-top"}>
                        <MdaeDateBox
                          id="dtpRescheduleDate"
                          mdaeDateBoxTitle="Rescheduled Date"
                          disabled={isBulkTaskAssignedToGroup}
                          mdaeDataUpdaterConfig={[
                            {
                              actionType: SET_USER_TASK_BULK_EDIT_DATA,
                              reducerName: "userTaskListReducer",
                              widgetOptionBindings: {
                                value: "userTaskBulkEditData.scheduledDate",
                              },
                            },
                          ]}
                        ></MdaeDateBox>
                      </div>
                      <div className={"widget-separation-margin-top"}>
                        <MdaeDateBox
                          id="dtpScheduleTime"
                          mdaeDateBoxTitle="Schedule Time"
                          disabled={isBulkTaskAssignedToGroup}
                          type={"time"}
                          mdaeDataUpdaterConfig={[
                            {
                              actionType: SET_USER_TASK_BULK_EDIT_DATA,
                              reducerName: "userTaskListReducer",
                              widgetOptionBindings: {
                                value: "userTaskBulkEditData.scheduleTime",
                              },
                            },
                          ]}
                        ></MdaeDateBox>
                      </div>
                    </div>
                  )}
                </div>
              </MdaePopupContent>
            );
          }
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"btnCancelUserTask"}
                  role={"secondary"}
                  onClick={() => {
                    props.toggleBulkEditUserTaskPopup(false);
                    props.toggleUserTaskGridCheckboxesForMyTask();
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"btnUpdateUserTask"}
                  validationGroup={BulkEditUserTaskValidationGroup}
                  onClick={(params) => {
                    updateUserTaskData(params, true);
                  }}
                  role={"primary"}
                >
                  Update
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      ></MdaePopup>
    </>
  );
};
export default BulkEditUserTaskPopup;
